import { ZAttrMeta } from "src/business/attribute";

import { OptionRecord } from "./OptionRecord";

const recCvt = ({ id, label }: OptionRecord) => ({ id, label });
const recCvtOpt = (rec: OptionRecord | undefined) => (rec ? recCvt(rec) : rec);

export const makeMetaFromOrderRecord = (
  srcMeta: ZAttrMeta,
  srcOptions: OptionRecord[] | undefined,
): ZAttrMeta => {
  const options = srcOptions ? [...srcOptions] : [];
  options.sort((a, b) => {
    const dOrder = (a.order ?? 0) - (b.order ?? 0);
    return dOrder === 0
      ? a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      : dOrder;
  });
  const dstMeta: ZAttrMeta = JSON.parse(JSON.stringify(srcMeta));
  if (dstMeta.type.name === "strOption") {
    dstMeta.type.defaultValue = recCvtOpt(
      options.find(({ isDefault }) => isDefault),
    );
  }
  const comp = dstMeta.edit?.component;
  if (comp?.type === "Select" && comp.options.type === "inline") {
    comp.options.list = options.map(recCvt);
  }
  return dstMeta;
};
